// "CPU" at the front of a customer-pickup event's name (Alex, 2026-10-21: the name should "start with CPU"). R2 owns
// events.name and rewrites it on every import, and many R2 names already end in "CPU", so this is display only: a
// leading or trailing "CPU" in the stored name is folded into the one at the front, and the stored name never changes.
const LEADING_CPU = /^\s*CPU\b[\s\-–—·:|/]*/i;
const TRAILING_CPU = /[\s\-–—·:|/,(]*\bCPU\b[\s)]*$/i;

export function eventDisplayName(name: string | null | undefined, customerPickup: boolean | null | undefined, fallback = ''): string {
  const stored = (name ?? '').trim() || fallback;
  if (!customerPickup || !stored) return stored;
  const core = stored.replace(LEADING_CPU, '').replace(TRAILING_CPU, '').trim();
  return core ? `CPU · ${core}` : 'CPU';
}
